import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type AutomationsCountColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const automationsCountColumnConfig = <T extends TableRow>({
  options,
}: AutomationsCountColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'automations',
  label: <Trans i18nKey="automations" />,
  acessorKey: 'automationsCount',
  sortable: true,
  ...options,
});
